function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FixedSizeList as List } from 'react-window';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize, faWindowMinimize, faSync } from '@fortawesome/free-solid-svg-icons';
import TrackRow from './TrackRow';
import './NearbyTrackList.css';
var ROW_HEIGHT = 150;

var NearbyTrackList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NearbyTrackList, _React$PureComponent);

  function NearbyTrackList(props) {
    var _this;

    _classCallCheck(this, NearbyTrackList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NearbyTrackList).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onOrientationChange", function (e) {
      if (_this.resizeTimeout) {
        clearTimeout(_this.resizeTimeout);
      }

      _this.resizeTimeout = setTimeout(function () {
        _this.setState({
          width: innerWidth,
          maxHeight: innerHeight - 77 - 25 - 25 - 70
        });
      }, 100);
    });

    _defineProperty(_assertThisInitialized(_this), "renderRow", function (_ref) {
      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;
      var _this$props = _this.props,
          app = _this$props.app,
          nearbyTracks = _this$props.nearbyTracks,
          currentLocation = _this$props.currentLocation;
      var track = nearbyTracks[index];
      return React.createElement("div", {
        className: "track-row-container",
        key: track.id,
        style: style,
        onClick: function onClick(e) {
          return app.setActiveTrack(track);
        }
      }, React.createElement(TrackRow, {
        app: app,
        track: track,
        currentLocation: currentLocation,
        key: track.id.toString()
      }));
    });

    _this.state = {
      maxHeight: innerHeight - 77 - 25 - 25 - 70,
      minimized: false,
      width: innerWidth
    };
    return _this;
  }

  _createClass(NearbyTrackList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('orientationchange', this.onOrientationChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('orientationchange', this.onOrientationChange);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var renderRow = this.renderRow;
      var _this$props2 = this.props,
          app = _this$props2.app,
          nearbyTracks = _this$props2.nearbyTracks;
      var _this$state = this.state,
          width = _this$state.width,
          maxHeight = _this$state.maxHeight,
          minimized = _this$state.minimized;
      return React.createElement("div", {
        className: "nearby-track-list ".concat(this.props.searchMode === 'trackLocator' ? 'show' : 'hide')
      }, React.createElement("div", {
        className: "header ".concat(nearbyTracks.length === 0 ? 'no-tracks' : '')
      }, React.createElement("div", {
        className: "title"
      }, nearbyTracks.length === 0 && React.createElement("div", {
        className: "caption"
      }, "no tracks within 100 miles"), nearbyTracks.length > 0 && React.createElement("div", {
        className: "count"
      }, nearbyTracks.length), nearbyTracks.length === 1 && React.createElement("div", {
        className: "caption"
      }, "track nearby"), nearbyTracks.length > 1 && React.createElement("div", {
        className: "caption"
      }, "tracks nearby")), minimized && React.createElement("div", {
        className: "maximize",
        onClick: function onClick(e) {
          return _this2.setState({
            minimized: false
          });
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faWindowMaximize
      })), !minimized && React.createElement("div", {
        className: "minimize",
        onClick: function onClick(e) {
          return _this2.setState({
            minimized: true
          });
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faWindowMinimize
      })), React.createElement("div", {
        className: "refresh",
        onClick: function onClick(e) {
          return app.refreshData();
        }
      }, React.createElement(FontAwesomeIcon, {
        icon: faSync
      }))), this.props.searchMode === 'trackLocator' && React.createElement(List, {
        className: "nearby-track-row-list ".concat(minimized ? 'minimized' : ''),
        height: minimized ? 0 : Math.min(maxHeight, nearbyTracks.length * ROW_HEIGHT),
        itemCount: nearbyTracks.length,
        itemSize: ROW_HEIGHT - 10,
        width: width - 46
      }, renderRow));
    }
  }]);

  return NearbyTrackList;
}(React.PureComponent);

export default NearbyTrackList;